import type { FeedServiceApiClient } from '@smapiot/piral-cloud-browser';
import { AuthClient } from './types';

let client: AuthClient;

export let http: FeedServiceApiClient;

function authorize(url: string) {
  return client.getAuthHeader().then((header) => {
    const [front, ...rest] = header.split(' ');
    const mode = front.toLowerCase();
    const token = rest.join(' ');
    return fetch(url, {
      method: 'post',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        token,
        mode,
      }),
    }).then(
      () =>
        (document.body.querySelector('#app').innerHTML =
          '<div class="app-center"><div><p><b>Successfully logged in.</b></p><p>You can now close this window.</p></div></div>'),
      () =>
        (document.body.querySelector('#app').innerHTML =
          '<div class="app-center"><div><p><b>Failed to log in.</b></p><p>We could not authorize the client. Please try again later.</p></div></div>'),
    );
  });
}

export function configureClient(authClient: AuthClient, hostUrl: string) {
  client = authClient;
  // @ts-ignore
  http = feedService.createServiceClient({
    resolveApiKey: getTokenHeader,
    apiKeyType: 'none',
    host: hostUrl,
  });
}

export function getTokenHeader() {
  return client.getAuthHeader();
}

export function isNotLoggedIn() {
  return !account();
}

export function account() {
  return client.account();
}

export function deviceLogin(key: string) {
  if (isNotLoggedIn()) {
    return client.login(key);
  } else {
    return authorize(http.getUrl(`auth/client/${key}`));
  }
}

export function login() {
  return client.login();
}

export function logout() {
  return client.logout();
}
